import NotificationEvents from '@Core/components/notificationBanner/events';
import Component from '@bythepixel/component-loader';
import Events from './events';

export default class Geolocator extends Component {
  static selector = '[data-comp-geolocator]';

  postition;
  geolocated = false;
  buttonClassLocating = 'map__geolocator--locating';
  buttonClassLocated = 'map__geolocator--located';

  constructor(...args) {
    super(...args);
    this.buttonText = this.$container.querySelector(
      '[data-geolocate-button-text]',
    );
    this.geolocateText = this.buttonText.innerHTML;

    this.mount();
  }

  attachListeners() {
    window.addEventListener('geolocate', () => {
      this.$container.click();
    });

    this.$container.addEventListener('click', () => {
      if (!this.geolocated) {
        this.geolocate();
        return;
      }

      this.resetButtonState();
      window.dispatchEvent(Events.GeolocateDisabled);
    });
  }

  geolocate() {
    if (!navigator.geolocation) {
      this.geolocateError('Geolocation is not supported by your browser.');

      return;
    }

    const errorText = 'We were unable to find your location. Please turn on location services to use your location.';
    this.buttonText.innerHTML = 'Finding...';
    this.$container.classList.add(this.buttonClassLocating);

    navigator.geolocation.getCurrentPosition(
      (position) => this.geolocateSuccess(position),
      (error) => this.geolocateError(errorText),
    );
  }

  geolocateSuccess(position) {
    this.position = position;
    this.geolocated = true;
    this.buttonText.innerHTML = 'Using my location';
    this.$container.classList.remove(this.buttonClassLocating);
    this.$container.classList.add(this.buttonClassLocated);

    window.dispatchEvent(NotificationEvents.Close);
    window.dispatchEvent(Events.Geolocated(position));
  }

  geolocateError(message) {
    this.resetButtonState();

    window.dispatchEvent(Events.GeolocateFailed);
    window.dispatchEvent(NotificationEvents.Notify(message));
  }

  resetButtonState() {
    this.position = null;
    this.geolocated = false;
    this.buttonText.innerHTML = this.geolocateText;
    this.$container.classList.remove(this.buttonClassLocating);
    this.$container.classList.remove(this.buttonClassLocated);
  }

  mount() {
    this.attachListeners();

    window.dispatchEvent(Events.GeolocateLoaded);
    window.Transwest.geolocator = this;
  }
}
